/**
 * Load Subnavigation from JSON
 * @function loadSubnavigation
 * @param {HTMLElement} element - current nav item
 */
function loadSubnavigation(element) {
  const apiUrl = element.dataset.ajaxNavServiceUrl;

  // Cache für bereits geladene Navigation
  if (!element.dataset.navloaded) {
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        const jsonNav = data.TopNavigationItem;
        const len = jsonNav.Childs.length;
        let nav_html = '';

        const new_level2_start = '<ul class="list-unstyled">';
        const new_level2_end = '</ul>';
        const new_level3_start =
          '<div class="level3 sub-menu"><div class="nav-sub"><ul class="list-unstyled">';
        const new_level3_end = '</ul></div></div>';
        const new_level4_start =
          '<div class="level4 sub-menu"><div class="nav-sub"><ul class="list-unstyled">';
        const new_level4_end = '</ul></div></div>';

        let backLabel = 'back';

        // Sprache prüfen
        if (document.documentElement.lang === 'de-DE') {
          backLabel = 'zurück';
        }

        // Custom Back-Button Text
        const backDataAttr = document.querySelector(
          '.nav-main[data-backbutton-text]',
        );
        if (backDataAttr && backDataAttr.dataset.backbuttonText) {
          backLabel = backDataAttr.dataset.backbuttonText;
        }

        // Navigation HTML generieren
        nav_html += new_level2_start;
        nav_html += get_mobile_item_html(jsonNav, backLabel);

        for (let i = 0; i < len; i++) {
          const level2 = jsonNav.Childs[i];
          const level2_length = level2.Childs.length;

          if (level2_length > 0) {
            nav_html += get_list_item_html(level2, false, true);
            nav_html += new_level3_start;
            nav_html += get_mobile_item_html(jsonNav.Childs[i], backLabel);

            for (let j = 0; j < level2_length; j++) {
              const level3 = level2.Childs[j];
              const level3_length = level3.Childs.length;

              if (level3_length > 0) {
                nav_html += get_list_item_html(level3, false, true);
                nav_html += new_level4_start;
                nav_html += get_mobile_item_html(level2.Childs[j], backLabel);

                for (let k = 0; k < level3_length; k++) {
                  const level4 = level3.Childs[k];
                  nav_html += get_list_item_html(level4);
                }

                nav_html += new_level4_end + '</li>';
              } else {
                nav_html += get_list_item_html(level3);
              }
            }

            nav_html += new_level3_end + '</li>';
          } else {
            nav_html += get_list_item_html(level2);
          }
        }

        nav_html += new_level2_end;

        // HTML in DOM einfügen
        const parentLi = element.closest('li');
        const navSubContainer = parentLi.querySelector('.level2 > .nav-sub');
        if (navSubContainer) {
          navSubContainer.querySelector('ul.list-unstyled').remove();
          navSubContainer.insertAdjacentHTML('afterbegin', nav_html);
        }

        activateTopMenu();
        getHeighestSubMenu();

        window.dispatchEvent(new Event('resize'));
      })
      .catch((error) => {
        console.error('Fehler beim Laden der Navigation:', error);
      });

    // Als geladen markieren
    element.dataset.navloaded = 'true';
  }

  // Helper Functions
  function get_list_item_html(item, selected, haschild, current) {
    let css_classes_li = '';
    let css_classes_a = '';
    let list_end = '</li>';
    let subline = '';

    if (selected) {
      css_classes_li += ' selected ';
      css_classes_a += ' selected ';
    }

    if (haschild) {
      css_classes_li += ' haschild ';
      css_classes_a += ' nav-layer-toggle ';
      list_end = '';
    }

    if (current) {
      css_classes_a += ' current ';
    }

    if (item.NavigationSubline && item.NavigationSubline !== '') {
      subline =
        '<span class="nav-subline">' + item.NavigationSubline + '</span>';
    }

    if (item.NavigationUrl && item.NavigationName) {
      return (
        '<li class="' +
        css_classes_li +
        '"><a class="' +
        css_classes_a +
        '" href="' +
        item.NavigationUrl +
        '"><span class="nav-text">' +
        item.NavigationName +
        '</span><svg class="icon icon-arrow icon-arrow-right" aria-hidden="true">' +
        '<use xlink:href="#ico-arrow-right"></use></svg>' +
        subline +
        '</a>' +
        list_end
      );
    }

    return '';
  }

  function get_mobile_item_html(item, backLabel) {
    if (item.NavigationUrl && item.NavigationName) {
      return (
        '<li><a class="nav-link-back" href="#"><svg class="icon icon-arrow icon-arrow-right icon-left" aria-hidden="true">' +
        '<use xlink:href="#ico-arrow-right"></use></svg><span>' +
        backLabel +
        '</span></a></li>' +
        '<li><a href="' +
        item.NavigationUrl +
        '" class="nav-mobile-only"><span class="nav-text">' +
        item.NavigationName +
        '</span><svg class="icon icon-arrow icon-arrow-right" aria-hidden="true">' +
        '<use xlink:href="#ico-arrow-right"></use></svg></a></li>'
      );
    }

    return '';
  }

  function activateTopMenu() {
    const currentpage = getCleanLink(globalThis.location.pathname + globalThis.location.hash);
    // Navigation Links als aktiv markieren
    // Compare the full path: an ends-with selector (href$=) let /kontakt also mark /investoren/kontakt.
    // "#" toggles are skipped, their resolved pathname is the current page.
    // External links are skipped too: https://example.com has the pathname "/" like the home page.
    const currentLinks = Array.prototype.filter.call(
      document.querySelectorAll('.level2 a:not(.nav-mobile-only):not([href^="#"])'),
      (link) =>
        link.origin === globalThis.location.origin &&
        getCleanLink(link.pathname + link.hash) === currentpage,
    );
    currentLinks.forEach((link) => {
      if (!link.classList.contains('selected')) {
        link.classList.add('selected');
        link.setAttribute('aria-current', 'true');

        let currentLi = link.closest('li');
        if (currentLi) {
          currentLi.classList.add('selected');

          // Alle Ebenen nach oben durchlaufen
          let currentSubMenu = currentLi.closest('div.sub-menu');
          while (currentSubMenu) {
            const parentLink = currentSubMenu.previousElementSibling;
            if (
              parentLink &&
              parentLink.tagName === 'A' &&
              !parentLink.classList.contains('nav-mobile-only')
            ) {
              parentLink.classList.add('selected');
              parentLink.setAttribute('aria-expanded', 'true');
              const parentLi = parentLink.closest('li');
              if (parentLi) {
                parentLi.classList.add('selected');
                // Weiter nach oben suchen
                currentSubMenu = parentLi.closest('div.sub-menu');
              } else {
                break;
              }
            } else {
              break;
            }
          }
        }
      }
    });
  }
}

// Verwendung der Funktion:
/**
 * Initialisiert Hover-Events für .nav-layer-toggle Elemente
 * @function initNavLayerToggleHover
 */
function initNavLayerToggleHover() {
  const navLayerToggles = document.querySelectorAll(
    '.nav-layer-toggle[data-ajax-nav-service-url]',
  );

  navLayerToggles.forEach((toggleElement) => {
    toggleElement.addEventListener('mouseenter', function () {
      // Nur bei Desktop-Ansicht (> 1024px) ausführen
      if (window.innerWidth > 1024) {
        loadSubnavigation(this);
      }
    });
  });
}
initNavLayerToggleHover();

function toggleExpandedState(element) {
  const isOpen = element.getAttribute('aria-expanded');

  element.setAttribute(
    'aria-expanded',
    isOpen === 'true' ? 'false' : 'true',
  );
}

function setBackgroundScrollLock(isLocked) {
  document.documentElement.classList.toggle('nav-scroll-lock', isLocked);
}

function handleNavToggleClick(navToggle, e) {
  e.preventDefault();
  toggleExpandedState(navToggle);
  setBackgroundScrollLock(navToggle.getAttribute('aria-expanded') === 'true');
  getHeighestSubMenu();
  document.body.style.setProperty(
    '--current-menu-height',
    document.querySelector('.nav-main--js-enabled').offsetHeight + 'px',
  );
  handleSearchPosition();
}

function closeNavigationOnOutsideClick(trgt) {
  if (trgt.closest('.navigation-wrapper')) {
    return;
  }

  const navToggle = document.querySelector('.nav-toggle');
  if (navToggle) {
    navToggle.setAttribute('aria-expanded', 'false');
  }
  setBackgroundScrollLock(false);
}

function handleLanguageSwitch(trgt) {
  const langSwitch = trgt.closest('.nav-lang .no-button');

  if (langSwitch) {
    toggleExpandedState(langSwitch);
    document.body.style.setProperty(
      '--current-menu-height',
      document.querySelector('.nav-lang-container').offsetHeight + 'px',
    );
    return true;
  }

  if (!trgt.closest('.nav-lang-container')) {
    const langButton = document.querySelector('.nav-lang .no-button');
    if (langButton) {
      langButton.setAttribute('aria-expanded', 'false');
    }
  }

  return false;
}

function handleTeaserToggle(trgt, e) {
  const teaserToggle = trgt.closest('#teaser-toggle');

  if (teaserToggle) {
    e.preventDefault();
    const isExpanded = teaserToggle.getAttribute('aria-expanded') === 'true';
    teaserToggle.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
    return true;
  }

  if (!trgt.closest('.nav-teaser-list')) {
    const teaserButton = document.querySelector('#teaser-toggle');
    if (teaserButton) {
      teaserButton.setAttribute('aria-expanded', 'false');
    }
  }

  return false;
}

function handleNavigationLayerActions(trgt, e) {
  const navLayerToggle = trgt.closest('.nav-layer-toggle');
  if (navLayerToggle) {
    e.preventDefault();
    handleNavLayerToggle(navLayerToggle);
    return true;
  }

  const navLinkBack = trgt.closest('.nav-link-back');
  if (navLinkBack) {
    e.preventDefault();
    handleNavLinkBack(navLinkBack);
    return true;
  }

  return false;
}

function handleBodyClick(e) {
  const trgt = e.target;
  const navToggle = trgt.closest('.nav-toggle');

  if (navToggle) {
    handleNavToggleClick(navToggle, e);
    return;
  }

  closeNavigationOnOutsideClick(trgt);
  handleLanguageSwitch(trgt);

  if (handleTeaserToggle(trgt, e)) {
    return;
  }

  handleNavigationLayerActions(trgt, e);
}


document.body.addEventListener('click', handleBodyClick);

// iOS lässt Touch-Scroll-Gesten trotz overflow:hidden manchmal an den
// Hintergrund durchsickern (Scroll Chaining) - dieser Guard unterdrückt das
// explizit, solange das Navigations-Overlay offen ist.
document.addEventListener(
  'touchmove',
  function (e) {
    if (
      document.documentElement.classList.contains('nav-scroll-lock') &&
      !e.target.closest('.navigation-wrapper')
    ) {
      e.preventDefault();
    }
  },
  { passive: false },
);

/**
 * Behandelt das Klicken auf .nav-layer-toggle Elemente
 * @param {HTMLElement} toggleElement - Das angeklickte .nav-layer-toggle Element
 */
function handleNavLayerToggle(toggleElement) {
  // Aktueller aria-expanded Status
  const isExpanded = toggleElement.getAttribute('aria-expanded') === 'true';

  // Alle anderen .nav-layer-toggle Elemente schließen (außer Parent-Elemente)
  const allNavLayerToggles = document.querySelectorAll(
    ".nav-layer-toggle[aria-expanded='true']",
  );
  const toggleElementParents = [];

  // Alle Parent-Elemente des aktuellen toggleElement sammeln
  let currentElement = toggleElement.closest('li');
  while (currentElement) {
    // Nach übergeordnetem li Element suchen
    const parentLi = currentElement.parentElement.closest('li');
    if (parentLi) {
      const parentToggle = parentLi.querySelector(
        ':scope > a.nav-layer-toggle',
      );
      if (parentToggle) {
        toggleElementParents.push(parentToggle);
      }
      currentElement = parentLi;
    } else {
      // Keine weiteren Parent-li Elemente gefunden
      break;
    }
  }

  allNavLayerToggles.forEach((toggle) => {
    if (toggle !== toggleElement && !toggleElementParents.includes(toggle)) {
      toggle.setAttribute('aria-expanded', 'false');
    }
  });

  // aria-expanded für das aktuelle Element toggleln
  toggleElement.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
  document.body.style.setProperty(
    '--current-menu-height',
    toggleElement.nextElementSibling.offsetHeight + 'px',
  );
}

/**
 * Behandelt das Klicken auf .nav-link-back Elemente
 * Navigiert zwei ul Elemente nach oben und setzt aria-expanded auf false
 * @param {HTMLElement} backLink - Das angeklickte .nav-link-back Element
 */
function handleNavLinkBack(backLink) {
  const firstUl = backLink.closest('ul');
  if (!firstUl) return;
  const secondUl = firstUl.parentElement.closest('ul');
  if (!secondUl) return;
  const navLayerToggle = secondUl.querySelector(
    ".nav-layer-toggle[aria-expanded='true']",
  );
  if (navLayerToggle) {
    navLayerToggle.setAttribute('aria-expanded', 'false');
  }
  document.body.style.setProperty(
    '--current-menu-height',
    navLayerToggle.closest('ul').offsetHeight + 'px',
  );
  if (navLayerToggle.closest('ul').classList.contains('nav-main--js-enabled')) {
    document.body.style.setProperty(
      '--current-menu-height',
      'calc(100vw - 160px)',
    );
  }
}

/**
 * Entfernt strong-Tags und fügt selected-Klasse zum parent li hinzu
 * @function removeStrongTagsAndAddSelectedClass
 */
function removeStrongTagsAndAddSelectedClass() {
  const navMain = document.querySelector('.nav-main--js-enabled');
  if (!navMain) {
    return;
  }

  const strongTags = navMain.querySelectorAll('strong');

  strongTags.forEach((strongTag) => {
    // Parent li Element finden
    const parentLi = strongTag.closest('li');
    if (parentLi) {
      // selected Klasse zum parent li hinzufügen
      parentLi.classList.add('selected');
    }

    const childLink = strongTag.querySelector('a');
    if (childLink) {
      // selected Klasse zum childLink hinzufügen
      childLink.classList.add('selected');
    }
    strongTag.before(childLink);

    strongTag.remove();
  });

  // A selected main item without children has no subnavigation that could mark the current page
  // (activateTopMenu only covers .level2), so mark the item itself.
  navMain
    .querySelectorAll(':scope > li.selected > a.selected:not(.nav-layer-toggle)')
    .forEach((link) => {
      link.setAttribute('aria-current', 'true');
    });
}

/**
 * Setzt aria-expanded="true" für Links in li.selected Elementen
 * @function setAriaExpandedForSelected
 */
function setAriaExpandedForSelected() {
  const selectedItems = document.querySelectorAll('li.selected');

  selectedItems.forEach((li) => {
    const directLink = li.querySelector(':scope > a');
    if (directLink && directLink.classList.contains('nav-layer-toggle')) {
      directLink.setAttribute('aria-expanded', 'true');
      if (directLink.hasAttribute('data-ajax-nav-service-url')) {
        loadSubnavigation(directLink);
      }
    }
  });
}

function getHeighestSubMenu() {
  const subMenus = document.querySelectorAll('.sub-menu');
  let maxHeight = 0;
  const navTeaserList = document.querySelector('.nav-teaser-list');

  subMenus.forEach((element) => {
    const height = element.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });
  if (navTeaserList && !navTeaserList.classList.contains('nav-teaser-list--active') && navTeaserList.offsetHeight > maxHeight) {
    // JEN-10346 maxHeight = navTeaserList.offsetHeight;
    navTeaserList.classList.add('nav-teaser-list--active');
  }
  document.body.style.setProperty('--max-submenu-height', maxHeight + 'px');
}

function initDOMManipulations() {
  if (!document.querySelector('.nav-main')) {
    return;
  }
  document.querySelector('.nav-main').classList.add('nav-main--js-enabled');
  document.querySelector('.nav-main--js-enabled').classList.remove('nav-main');
  removeStrongTagsAndAddSelectedClass();
  setAriaExpandedForSelected();
  replaceSearchButtonIcon();

  // Teaser Toggle Button zur nav-meta hinzufügen - nur wenn es auch eine Teaser-Liste zum Aufklappen
  // gibt. Das Intranet rendert seit JEN-11381 eine .nav-meta, aber keine .nav-teaser-list; ohne diese
  // Bedingung entstuende dort ein "Highlights"-Button, der beim Klick nichts oeffnet.
  const navMeta = document.querySelector('.nav-meta');
  const navTeaserList = document.querySelector('.nav-teaser-list');
  if (navMeta && navTeaserList) {
    const teaserLi = document.createElement('li');
    const teaserButton = document.createElement('button');
    teaserLi.classList.add('teaser-toggle');
    teaserButton.type = 'button';
    teaserButton.id = 'teaser-toggle';
    teaserButton.setAttribute('aria-expanded', 'false');
    teaserButton.classList.add('no-button');
    let highlightsLabel = 'Highlights';
    if (navTeaserList && navTeaserList.dataset.highlightsLabel) {
      highlightsLabel = navTeaserList.dataset.highlightsLabel;
    }
    teaserButton.textContent = highlightsLabel;
    teaserLi.appendChild(teaserButton);
    navMeta.appendChild(teaserLi);

    let closeHighlightsLabel = 'Back';
    if (navTeaserList && navTeaserList.dataset.closeHighlightsLabel) {
      closeHighlightsLabel = navTeaserList.dataset.closeHighlightsLabel;
    }
    if (navTeaserList) {
      if (window.innerWidth < 1200) {
        const closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.classList.add('close-highlights');
        closeButton.innerHTML =
          '<svg class="icon icon-arrow icon-arrow-right icon-left" aria-hidden="true"><use xlink:href="#ico-arrow-right"></use></svg>';
        const closeSpan = document.createElement('span');
        closeSpan.textContent = closeHighlightsLabel;
        closeButton.appendChild(closeSpan);

        closeButton.addEventListener('click', function () {
          document.querySelector('#teaser-toggle').click();
        });

        navTeaserList.prepend(closeButton);
      }
    }
  }

  if (window.innerWidth < 1200) {
    setTimeout(function () {
      const navLayerToggles = document.querySelectorAll(
        '.nav-layer-toggle[data-ajax-nav-service-url]',
      );
      navLayerToggles.forEach((toggleElement) => {
        loadSubnavigation(toggleElement);
      });
    }, 100);
  }
}


  function getCleanLink(link) {
    if (!link) {
      return undefined;
    }
    if (link.includes('%')) {
      link = decodeURI(link);
    }
    const regex = /([?&])sc_site=[^&#]*(&?)/;
    const newlink = link.replace(regex, (match, p1, p2) => {
      return p2 ? p1 : '';
    });

    return newlink.toLowerCase();
  }

/**
 * Verschiebt die Suche basierend auf der Bildschirmbreite
 * < 1200px: .search-open und .search-container werden hinter .nav-toggle verschoben, li wird entfernt
 * >= 1200px: .search-open und .search-container werden zurück ins li verschoben
 */
function handleSearchPosition() {
  const searchLi = document.querySelector(
    '.nav-main--js-enabled li:has(.search-open)',
  );
  const navWrapper = document.querySelector('.navigation-wrapper');
  const navMainList = document.querySelector('.nav-main--js-enabled');
  const searchOpen = document.querySelector('.search-open');
  const searchContainer = document.querySelector('.search-container');

  if (!navWrapper || !navMainList || !searchOpen || !searchContainer) {
    return;
  }

  if (window.innerWidth > 1200 && document.querySelector('.nav-toggle[aria-expanded="true"]')) {

    if (!searchLi || searchLi.parentElement !== navMainList) {
      let newSearchLi = document.querySelector(
        '.nav-main--js-enabled li:has(.search-open)',
      );

      if (!newSearchLi) {
        newSearchLi = document.createElement('li');
        navMainList.appendChild(newSearchLi);
      }

      newSearchLi.appendChild(searchOpen);
      newSearchLi.appendChild(searchContainer);
    }
  } else if (searchLi && searchLi.parentElement === navMainList) {
      navWrapper.after(searchContainer);
      navWrapper.after(searchOpen);
      searchLi.remove();
  }
}

/**
 * Replaces svg.icon-arrow.icon-arrow-right in .search-controls button.btn
 * with a clone of .search-open svg.icon-search
 */
function replaceSearchButtonIcon() {
  const arrowIcon = document.querySelector(
    '.search-controls button.btn svg.icon-arrow.icon-arrow-right',
  );
  const searchIcon = document.querySelector('.search-open svg.icon-search');

  if (!arrowIcon || !searchIcon) {
    return;
  }

  arrowIcon.replaceWith(searchIcon.cloneNode(true));
}

/**
 * Throttle-Funktion für Resize-Events
 */
function throttle(func, delay) {
  let timeout = null;
  return function () {
    if (!timeout) {
      timeout = setTimeout(() => {
        func();
        timeout = null;
      }, delay);
    }
  };
}

// Resize-Event Handler mit Throttle
window.addEventListener('resize', throttle(handleSearchPosition, 150));

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initDOMManipulations();
    handleSearchPosition();
  });
} else {
  initDOMManipulations();
  handleSearchPosition();
}
